// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { getIconPath } from '@tcp/core/src/utils';
import {
  CustomRankingContainer,
  RatingsWrapper,
  RatingStarOverlay,
  RatingStarGrey,
  RatingStarMain,
  ReviewsCount,
} from '../styles/RatingsAndReviews.style';
import SafeComponent from '../../../../../../common/hoc/withErrorBoundary/errorBoundary';

const RatingsAndReviews = ({ ratings, reviewsCount }) => {
  const reviewsCountNumber = Number(reviewsCount);
  const starsRatingWhite = getIconPath('stars-rating');

  return (
    <>
      {Number(ratings) > 0 && reviewsCountNumber > 0 && (
        <CustomRankingContainer className="custom-ranking-container">
          <RatingsWrapper aria-label={`rating of this product is ${ratings} out of 5`}>
            <RatingStarOverlay className="rating-star-overlay" ratings={ratings} aria-hidden={true}>
              <RatingStarMain
                src={starsRatingWhite}
                title={`Product ratings - ${ratings}`}
                alt="Star Rating Icon"
                className="rating-star-main"
              />
            </RatingStarOverlay>
            <RatingStarGrey
              aria-hidden={true}
              src={starsRatingWhite}
              title="Product ratings"
              alt="Star Rating Icon"
              className="rating-star-grey"
              ratings={ratings}
            />
          </RatingsWrapper>
          <ReviewsCount
            component="span"
            fontFamily="secondary"
            fontSize="fs12"
            className="reviews-count"
            aria-label={`${reviewsCountNumber} reviews`}
          >
            {reviewsCountNumber}
          </ReviewsCount>
        </CustomRankingContainer>
      )}
    </>
  );
};

RatingsAndReviews.propTypes = {
  ratings: PropTypes.number,
  reviewsCount: PropTypes.number,
};

RatingsAndReviews.defaultProps = {
  ratings: 0,
  reviewsCount: 0,
};

export default SafeComponent(RatingsAndReviews);
